import axios from 'axios'
// const env = 'TESTING'
const env = 'LIVE'

let baseUrl, resetUrl, mailLink, confirmUrl;

if (env === 'TESTING') {
  baseUrl = 'http://10.10.0.1:4000'
  resetUrl = 'http://10.10.0.1:3000/reset_password'
  mailLink = "info@instalevel.nimbleblocks.com"
  confirmUrl = 'http://10.10.0.1:3000/confirm'
} else {
  baseUrl = 'https://api.instalevel.org';
  resetUrl = 'https://admin.instalevel.org/reset_password'
  mailLink = "info@instalevel.org"
  confirmUrl = 'https://admin.instalevel.org/confirm'
}

axios.defaults.baseURL = baseUrl;
axios.defaults.headers.common['Content-Type'] = 'application/json;charset=utf-8'
let userdata = JSON.parse( localStorage.getItem('userdata') ) || false

//HTTP BASIC AUTH
// axios.defaults.headers.common['Authorization'] = 'Basic c2ZtdGVzdDpub2luZGV4'


if ( userdata ) {
  axios.defaults.headers.common['X-User-Uid'] = userdata['uid']
  axios.defaults.headers.common['X-User-Token'] = userdata['token']
}

function reset_axios() {
  let userdata = JSON.parse( localStorage.getItem('userdata') ) || false

  if ( userdata ) {
    axios.defaults.headers.common['X-User-Uid'] = userdata['uid']
    axios.defaults.headers.common['X-User-Token'] = userdata['token']
  } else {
    delete axios.defaults.headers.common['X-User-Uid']
    delete axios.defaults.headers.common['X-User-Token']
  }
}

const updateProgress = (progressEvent) => {
  if (progressEvent.lengthComputable) {
    const { loaded, total } = progressEvent
    const progress = Math.round(loaded/total*100)
    return {
      type: "UPDATE_PROGRESS_BAR",
      payload: progress
    }
  }
}

export { axios, reset_axios, baseUrl, resetUrl, confirmUrl, mailLink, updateProgress }



// WEBPACK FOOTER //
// ./src/js/services/index.js